function operationalStatuses(status) {
	switch (status) {
	case operationalStatuses.cancelled:
		return 'cancelled';
	case operationalStatuses.draft:
		return 'draft';
	case operationalStatuses.ready:
		return 'ready';
	case operationalStatuses.planned:
		return 'planned';
	case operationalStatuses.rejected:
		return 'rejected';
	case operationalStatuses.unsuccessful:
		return 'unsuccessful';
	case operationalStatuses.requested:
		return 'requested';
	case operationalStatuses.received:
		return 'received';
	case operationalStatuses.accepted:
		return 'accepted';
	case operationalStatuses.readyForPickup:
		return 'readyForPickup';
	case operationalStatuses.loaded:
		return 'loaded';
	case operationalStatuses.unloaded:
		return 'unloaded';
	default:
		return undefined;
	}
}

operationalStatuses.cancelled = -10;
operationalStatuses.draft = 0;
operationalStatuses.ready = 10;
operationalStatuses.planned = 20;
operationalStatuses.rejected = 30;
operationalStatuses.unsuccessful = 40;
operationalStatuses.requested = 50;
operationalStatuses.received = 60;
operationalStatuses.accepted = 70;
operationalStatuses.readyForPickup = 75;
operationalStatuses.loaded = 80;
operationalStatuses.unloaded = 90;

export default operationalStatuses;